import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vModelText as _vModelText, normalizeClass as _normalizeClass, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-1 text-left" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-bold text-textPrimary" }, "Avaliar registro", -1)
const _hoisted_3 = {
  key: 0,
  class: "text-sm text-neutral50"
}
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col lg:flex-row gap-6 text-left"
}
const _hoisted_5 = { class: "flex-1 min-w-0" }
const _hoisted_6 = { class: "w-full lg:w-[380px] shrink-0 flex flex-col gap-4" }
const _hoisted_7 = { class: "flex flex-col gap-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "text-base font-semibold text-textPrimary" }, "Decisão", -1)
const _hoisted_9 = {
  class: "flex items-center gap-2 cursor-pointer",
  "data-testid": "check-validation-approve-radio"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "text-base text-textPrimary" }, "Aprovar", -1)
const _hoisted_11 = {
  class: "flex items-center gap-2 cursor-pointer",
  "data-testid": "check-validation-reject-radio"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text-base text-textPrimary" }, "Reprovar", -1)
const _hoisted_13 = { class: "flex flex-col gap-1.5" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "text-negative" }, "*", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-neutral50" }, "O motivo é registrado no histórico do registro.", -1)
const _hoisted_16 = {
  key: 0,
  class: "flex flex-col gap-1"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  class: "text-sm font-bold text-textPrimary",
  for: "check-validation-rejection-observation"
}, [
  /*#__PURE__*/_createTextVNode(" Observação "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-negative" }, "*")
], -1)
const _hoisted_18 = ["placeholder"]
const _hoisted_19 = { class: "flex gap-4 w-full" }
const _hoisted_20 = { class: "flex-1" }
const _hoisted_21 = { class: "flex-1" }

import { computed, ref, watch } from 'vue'

import Modal from '@/components/designSystem/modals/Modal.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import { CheckRejectionReason } from '@/Network/Types/Responses/CheckValidationResponses'
import {
  CHECK_REJECTION_OBSERVATION_MIN_LENGTH,
  CHECK_REJECTION_REASON_OPTIONS
} from '@/constants/check-validation.constants'

import CheckEvidencePanel from './CheckEvidencePanel.vue'
import type { CheckEvidenceContext } from './CheckEvidencePanel.vue'
import CheckSummaryCard from './CheckSummaryCard.vue'
import type { CheckValidationRow } from '../types'

export interface ApproveCheckPayload {
  checkId: number
  version: number
}

export interface RejectCheckModalPayload extends ApproveCheckPayload {
  reason: CheckRejectionReason
  observation?: string
}

type Decision = 'APPROVE' | 'REJECT' | ''

// Modal "burro": não chama Network. Emite a decisão e o pai (Index) fala com o
// store, toasta e decide fechar/recarregar — inclusive no 409.

export default /*#__PURE__*/_defineComponent({
  __name: 'EvaluateCheckModal',
  props: {
    modelValue: { type: Boolean },
    row: {},
    saving: { type: Boolean },
    queuePosition: { default: 0 },
    queueTotal: { default: 0 }
  },
  emits: ["update:modelValue", "approve", "reject", "evidenceUnavailable", "evidenceAvailable"],
  setup(__props: any, { emit }) {

const props = __props;





const decision = ref<Decision>('')
const reason = ref<CheckRejectionReason | ''>('')
const observation = ref('')
const context = ref<CheckEvidenceContext | null>(null)

const trimmedObservationLength = computed(() => observation.value.trim().length)
const isObservationValid = computed(
  () => trimmedObservationLength.value >= CHECK_REJECTION_OBSERVATION_MIN_LENGTH
)

// Espelha o backend: motivo obrigatório na reprovação; observação (≥ 20) só em OTHER.
const canSubmit = computed(() => {
  if (!props.row) return false
  if (decision.value === 'APPROVE') return true
  if (decision.value !== 'REJECT') return false
  if (!reason.value) return false
  if (reason.value === CheckRejectionReason.OTHER) return isObservationValid.value
  return true
})

const confirmLabel = computed(() => {
  if (decision.value === 'APPROVE') return 'Aprovar registro'
  if (decision.value === 'REJECT') return 'Reprovar registro'
  return 'Confirmar'
})

function resetForm() {
  decision.value = ''
  reason.value = ''
  observation.value = ''
  context.value = null
}

// Nova linha ou reabertura: o formulário nunca reabre com a decisão anterior.
watch(
  () => [props.row?.checkId, props.modelValue],
  () => resetForm()
)

function onEvidenceLoaded(loaded: CheckEvidenceContext) {
  context.value = loaded
}

function submit() {
  if (!props.row || !canSubmit.value) return
  const base = { checkId: props.row.checkId, version: props.row.version }
  if (decision.value === 'APPROVE') {
    emit('approve', base)
    return
  }
  const payload: RejectCheckModalPayload = { ...base, reason: reason.value as CheckRejectionReason }
  if (reason.value === CheckRejectionReason.OTHER) payload.observation = observation.value.trim()
  emit('reject', payload)
}

// Não fecha com approve/reject em voo: o pai decide fechar no sucesso/409.
function close() {
  if (props.saving) return
  emit('update:modelValue', false)
}

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createBlock(Modal, {
    "modal-active": _ctx.modelValue,
    "has-header-border": "",
    "has-footer-border": "",
    "max-width": "max-w-6xl",
    onClose: close
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        (_ctx.queueTotal > 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, " Evidência " + _toDisplayString(_ctx.queuePosition) + " de " + _toDisplayString(_ctx.queueTotal) + " " + _toDisplayString(_ctx.queueTotal === 1 ? 'avaliação' : 'avaliações'), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createVNode(OutlineButton, {
            text: "Fechar",
            width: "100%",
            height: "48px",
            disabled: _ctx.saving,
            "data-testid": "check-validation-evaluate-cancel-button",
            onClick: close
          }, null, 8, ["disabled"])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createVNode(FilledButton, {
            text: confirmLabel.value,
            width: "100%",
            height: "48px",
            disabled: !canSubmit.value || _ctx.saving,
            "data-testid": "check-validation-evaluate-confirm-button",
            onClick: submit
          }, null, 8, ["text", "disabled"])
        ])
      ])
    ]),
    default: _withCtx(() => [
      (_ctx.row)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(CheckEvidencePanel, {
                "check-id": _ctx.row.checkId,
                onLoaded: onEvidenceLoaded,
                onUnavailable: _cache[0] || (_cache[0] = ($event: any) => (emit('evidenceUnavailable', _ctx.row.checkId))),
                onAvailable: _cache[1] || (_cache[1] = ($event: any) => (emit('evidenceAvailable', _ctx.row.checkId)))
              }, null, 8, ["check-id"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(CheckSummaryCard, {
                row: _ctx.row,
                "typed-hours": context.value ? { checkin: context.value.checkin, checkout: context.value.checkout } : null,
                timezone: context.value?.timezone ?? '',
                "doctor-name-override": context.value?.doctorName ?? null,
                crm: context.value?.crm ?? null
              }, null, 8, ["row", "typed-hours", "timezone", "doctor-name-override", "crm"]),
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("label", _hoisted_9, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((decision).value = $event)),
                    type: "radio",
                    value: "APPROVE",
                    class: "w-5 h-5 accent-[#2f7f91]",
                    "data-testid": "check-validation-approve-radio-input"
                  }, null, 512), [
                    [_vModelRadio, decision.value]
                  ]),
                  _hoisted_10
                ]),
                _createElementVNode("label", _hoisted_11, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((decision).value = $event)),
                    type: "radio",
                    value: "REJECT",
                    class: "w-5 h-5 accent-[#2f7f91]",
                    "data-testid": "check-validation-reject-radio-input"
                  }, null, 512), [
                    [_vModelRadio, decision.value]
                  ]),
                  _hoisted_12
                ])
              ]),
              (decision.value === 'REJECT')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_v_select, {
                        modelValue: reason.value,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((reason).value = $event)),
                        items: _unref(CHECK_REJECTION_REASON_OPTIONS),
                        "item-title": "title",
                        "item-value": "value",
                        variant: "outlined",
                        density: "comfortable",
                        "hide-details": "auto",
                        "data-testid": "check-validation-rejection-reason-select"
                      }, {
                        label: _withCtx(() => [
                          _createTextVNode(" Motivo da reprovação "),
                          _hoisted_14
                        ]),
                        _: 1
                      }, 8, ["modelValue", "items"]),
                      _hoisted_15
                    ]),
                    (reason.value === _unref(CheckRejectionReason).OTHER)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _hoisted_17,
                          _withDirectives(_createElementVNode("textarea", {
                            id: "check-validation-rejection-observation",
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((observation).value = $event)),
                            class: "w-full border border-gray-300 rounded-lg p-3 text-sm text-textPrimary resize-none focus:outline-none focus:ring-2 focus:ring-primary30",
                            rows: "3",
                            placeholder: `Descreva o motivo (mín. ${_unref(CHECK_REJECTION_OBSERVATION_MIN_LENGTH)} caracteres)`,
                            "data-testid": "check-validation-rejection-observation-input"
                          }, null, 8, _hoisted_18), [
                            [_vModelText, observation.value]
                          ]),
                          _createElementVNode("span", {
                            class: _normalizeClass(["self-end text-xs whitespace-nowrap", isObservationValid.value ? 'text-neutral50' : 'text-negative']),
                            "data-testid": "check-validation-rejection-char-counter"
                          }, _toDisplayString(trimmedObservationLength.value) + "/" + _toDisplayString(_unref(CHECK_REJECTION_OBSERVATION_MIN_LENGTH)), 3)
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modal-active"]))
}
}

})